export const ExclamationCircleFillIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.6328 45.7461C36.2308 45.7461 45.6328 36.3441 45.6328 24.7461C45.6328 13.1481 36.2308 3.74609 24.6328 3.74609C13.0348 3.74609 3.63281 13.1481 3.63281 24.7461C3.63281 36.3441 13.0348 45.7461 24.6328 45.7461ZM22.1501 16.0899C22.1171 14.6953 23.2386 13.5469 24.6336 13.5469C26.0286 13.5469 27.1501 14.6953 27.117 16.0899L26.8639 26.769C26.8352 27.9802 25.8451 28.9471 24.6336 28.9471C23.422 28.9471 22.432 27.9802 22.4032 26.769L22.1501 16.0899ZM27.0328 33.4352C27.0328 34.7933 25.9925 35.8352 24.6237 35.8352C23.2914 35.8352 22.2328 34.7933 22.2328 33.4352C22.2328 32.077 23.2914 31.0352 24.6237 31.0352C25.9925 31.0352 27.0328 32.077 27.0328 33.4352Z"
      fill="#FF8800"
    />
  </svg>
)

export default ExclamationCircleFillIcon
